import { Component, Input, OnInit } from "@angular/core";
import { ItemWithRelations } from "src/app/api/models";

@Component({
  selector: "art-item-inventory-code",
  templateUrl: "./item-inventory-code.component.html",
  styleUrls: ["./item-inventory-code.component.scss"],
  standalone: false,
})
export class ItemInventoryCodeComponent implements OnInit {
  @Input() item: ItemWithRelations;
  @Input() align: "center" | "left" = "left";
  @Input() addPadding: boolean = false;

  constructor() {}

  ngOnInit(): void {}
}
